import { pxToRems } from '@awaze/design-system.utils.react';
import styled, { css } from 'styled-components';
import { InputStyles, } from './input.styles';
export const DatePickerContainerStyled = styled.div `
  position: relative;
`;
export const DatePickerDisplayStyled = styled.div `
  ${InputStyles}

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  padding-right: ${pxToRems(18)};

  ${({ placeholderActive, theme }) => placeholderActive &&
    css `
      color: ${theme.ColorGrey400};
      > svg path {
        fill: ${theme.ColorGrey400};
      }
    `}

  > svg {
    flex-shrink: 0;
  }
`;
export const DatePickerStyled = styled.input `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  appearance: none;
  user-select: none;

  &::-webkit-calendar-picker-indicator {
    position: absolute;
    top: -150%;
    left: -150%;
    width: 300%;
    height: 300%;
  }

  &:focus {
    & + ${DatePickerDisplayStyled} {
      border-color: ${({ theme }) => theme.ColorBrandPrimary};
      outline: 1px solid ${({ theme }) => theme.ColorBrandPrimary};
    }
  }
`;
//# sourceMappingURL=date-picker.styles.js.map